import { ConnectorType, ConnectorCatalogEntry, ConnectorConfig } from '../types';

export const CONNECTOR_COLORS: Record<ConnectorType, string> = {
  shopify: '#96BF48',
  woocommerce: '#9B5C8F',
  prestashop: '#DF0067',
  magento: '#F26322',
  drupal: '#0678BE',
  simple_db: '#6B7280',
};

export const TRIGGER_NODE_COLOR = '#F59E0B';
export const MAPPING_NODE_COLOR = '#8B5CF6';
export const DESTINATION_NODE_COLOR = '#3B82F6';

export const CONNECTOR_CATALOG: ConnectorCatalogEntry[] = [
  {
    type: 'shopify',
    nameKey: 'PAGES.API_INTEGRATION.CONNECTORS.SHOPIFY',
    category: 'ecommerce',
    color: CONNECTOR_COLORS.shopify,
    configFields: [
      { key: 'storeUrl', labelKey: 'PAGES.API_INTEGRATION.FIELDS.STORE_URL', type: 'text', placeholder: 'mystore.myshopify.com' },
      { key: 'apiKey', labelKey: 'PAGES.API_INTEGRATION.FIELDS.API_KEY', type: 'text' },
      { key: 'apiSecret', labelKey: 'PAGES.API_INTEGRATION.FIELDS.API_SECRET', type: 'password' },
    ],
  },
  {
    type: 'woocommerce',
    nameKey: 'PAGES.API_INTEGRATION.CONNECTORS.WOOCOMMERCE',
    category: 'ecommerce',
    color: CONNECTOR_COLORS.woocommerce,
    configFields: [
      { key: 'storeUrl', labelKey: 'PAGES.API_INTEGRATION.FIELDS.STORE_URL', type: 'text', placeholder: 'https://mystore.com', helperTextKey: 'PAGES.API_INTEGRATION.FIELDS.WOO_STORE_URL_HINT' },
      { key: 'consumerKey', labelKey: 'PAGES.API_INTEGRATION.FIELDS.CONSUMER_KEY', type: 'text', helperTextKey: 'PAGES.API_INTEGRATION.FIELDS.WOO_API_KEYS_HINT' },
      { key: 'consumerSecret', labelKey: 'PAGES.API_INTEGRATION.FIELDS.CONSUMER_SECRET', type: 'password' },
    ],
  },
  {
    type: 'prestashop',
    nameKey: 'PAGES.API_INTEGRATION.CONNECTORS.PRESTASHOP',
    category: 'ecommerce',
    color: CONNECTOR_COLORS.prestashop,
    configFields: [
      { key: 'storeUrl', labelKey: 'PAGES.API_INTEGRATION.FIELDS.STORE_URL', type: 'text', placeholder: 'https://mystore.com', helperTextKey: 'PAGES.API_INTEGRATION.FIELDS.PS_STORE_URL_HINT' },
      { key: 'apiKey', labelKey: 'PAGES.API_INTEGRATION.FIELDS.API_KEY', type: 'text', helperTextKey: 'PAGES.API_INTEGRATION.FIELDS.PS_API_KEY_HINT' },
    ],
  },
  {
    type: 'magento',
    nameKey: 'PAGES.API_INTEGRATION.CONNECTORS.MAGENTO',
    category: 'ecommerce',
    color: CONNECTOR_COLORS.magento,
    configFields: [
      { key: 'storeUrl', labelKey: 'PAGES.API_INTEGRATION.FIELDS.STORE_URL', type: 'text', placeholder: 'https://mystore.com', helperTextKey: 'PAGES.API_INTEGRATION.FIELDS.MAGENTO_STORE_URL_HINT' },
      { key: 'accessToken', labelKey: 'PAGES.API_INTEGRATION.FIELDS.ACCESS_TOKEN', type: 'password', helperTextKey: 'PAGES.API_INTEGRATION.FIELDS.MAGENTO_TOKEN_HINT' },
    ],
  },
  {
    type: 'drupal',
    nameKey: 'PAGES.API_INTEGRATION.CONNECTORS.DRUPAL',
    category: 'other',
    color: CONNECTOR_COLORS.drupal,
    configFields: [
      { key: 'siteUrl', labelKey: 'PAGES.API_INTEGRATION.FIELDS.SITE_URL', type: 'text', placeholder: 'mysite.com' },
      { key: 'apiEndpoint', labelKey: 'PAGES.API_INTEGRATION.FIELDS.API_ENDPOINT', type: 'text', placeholder: '/jsonapi/node/product' },
      { key: 'authToken', labelKey: 'PAGES.API_INTEGRATION.FIELDS.AUTH_TOKEN', type: 'password' },
    ],
  },
  {
    type: 'simple_db',
    nameKey: 'PAGES.API_INTEGRATION.CONNECTORS.SIMPLE_DB',
    category: 'other',
    color: CONNECTOR_COLORS.simple_db,
    configFields: [
      { key: 'connectionString', labelKey: 'PAGES.API_INTEGRATION.FIELDS.CONNECTION_STRING', type: 'password', placeholder: 'mongodb://...' },
      { key: 'tableOrCollection', labelKey: 'PAGES.API_INTEGRATION.FIELDS.TABLE_OR_COLLECTION', type: 'text', placeholder: 'products' },
      { key: 'query', labelKey: 'PAGES.API_INTEGRATION.FIELDS.QUERY', type: 'textarea', placeholder: '{}' },
    ],
  },
];

export const getConnectorCatalogEntry = (type: ConnectorType): ConnectorCatalogEntry =>
  CONNECTOR_CATALOG.find(c => c.type === type)!;

export const getDefaultConnectorConfig = (type: ConnectorType): ConnectorConfig => {
  switch (type) {
    case 'shopify':
      return { connectorType: 'shopify', storeUrl: '', apiKey: '', apiSecret: '' };
    case 'woocommerce':
      return { connectorType: 'woocommerce', storeUrl: '', consumerKey: '', consumerSecret: '' };
    case 'prestashop':
      return { connectorType: 'prestashop', storeUrl: '', apiKey: '' };
    case 'magento':
      return { connectorType: 'magento', storeUrl: '', accessToken: '' };
    case 'drupal':
      return { connectorType: 'drupal', siteUrl: '', apiEndpoint: '', authToken: '' };
    case 'simple_db':
      return { connectorType: 'simple_db', connectionString: '', tableOrCollection: '', query: '' };
  }
};
